import React, { useEffect, useState, useRef, useContext } from "react";
import { DataContext } from "../../DataContext"; // Import the context
import "./SwapYourBike.scss";
import "../../pages/MyBykRent/HideLinks.scss";
import CrossIcon from "../../images/cross-mark-black.svg";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Video from "../../images/video-w-music.mp4";
import Thumbnail from "../../images/swap-my-byk-desk.png";
import ThumbnailMobile from "../../images/image.jpg";
import MyBykStationPin from "../../images/mybyk-location-pin-small.svg";
import MyBykStationPinBig from "../../images/mybyk-location-pin-big.svg";
import {
  LoadScript,
  GoogleMap,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import API_BASE_URL from "../../config";
import { useLocation, useNavigate } from "react-router-dom";

const MapEnv = process.env.REACT_APP_MAPS_API;
// Static bearer token from environment variables
const bearerToken = process.env.REACT_APP_BEARER_TOKEN;

const libraries = ["places"];
const SwapYourBike = () => {
  const { isValidParam } = useContext(DataContext);
  const inputRef = useRef(null);
  const mapRef = useRef(null);
  const location = useLocation();

  const [center, setCenter] = useState({ lat: 23.0517357, lng: 72.5474487 }); // Default coordinates
  const [zoom, setZoom] = useState(12); // Default zoom level
  const [mapHeight, setMapHeight] = useState("565px");
  const [activeMarker, setActiveMarker] = useState(null);
  //const [stationList, setStationList] = useState([]); // Dynamic station list
  const [isError, setIsError] = useState(false);
  const errorMessage = "No nearest hub data found";

  const queryParam = new URLSearchParams(location.search).get("q");

  useEffect(() => {
    if (!queryParam) return; // close if `q` is empty
    const updateMapHeight = () => {
      setMapHeight(window.innerWidth < 991 ? "398px" : "565px");
    };

    updateMapHeight();
    window.addEventListener("resize", updateMapHeight);

    return () => window.removeEventListener("resize", updateMapHeight);
  }, [queryParam]);

  useEffect(() => {
    // Bind FancyBox
    Fancybox.bind("[data-fancybox]", {
      Video: {
        autoplay: true,
      },
    });
    document.addEventListener("click", (event) => {
      if (event.target.closest('[data-fancybox="video-gallery"]')) {
        if (window.pauseYouTubeVideo) {
          window.pauseYouTubeVideo(); // Call the global function to pause YouTube videos
        }
      }
    });

    return () => Fancybox.destroy(); // Cleanup bindings
  }, []);

  const navigate = useNavigate();

  const hubdataurl = `${API_BASE_URL}WsClusterStationList.php`;
  const [mapData, setMapData] = useState([{ stationList: [] }]);

  useEffect(() => {
    if (!queryParam) return; // close if `q` is empty

    const initializeAutocomplete = () => {
      if (window.google && inputRef.current) {
        const autocomplete = new window.google.maps.places.Autocomplete(
          inputRef.current,
          {
            types: ["geocode"],
            componentRestrictions: { country: "IN" },
          }
        );

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (place.geometry) {
            const newCenter = {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            };
            setCenter({
              lat: parseFloat(newCenter.lat),
              lng: parseFloat(newCenter.lng),
            });
            setActiveMarker(newCenter.idStation);
            setZoom(16); 


            // Need to set API for serach hub
            const searchDataForMap = {
              // Define your request data here or ensure it's passed from elsewhere
              dashboard: queryParam,
              action: 'getstationlist',
              searchplace_lat: newCenter.lat,
              searchplace_long: newCenter.lng
            };

            const fetchSearchData = async () => {
              try {
                const response = await fetch(hubdataurl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `bearer ${bearerToken}`,
                  },
                  body: JSON.stringify(searchDataForMap),
                });

                const result = await response.json();

                if (response.ok) {
                  setMapData(result.data); // Update data on success
                  //console.log(result.data);
                } else {
                  // API returned an error
                  setMapData([]);
                }
              } catch (error) {
                setMapData([]);
              }
            };
            fetchSearchData();
          }
        });
      }
    };

    if (window.google) {
      setTimeout(() => {
        initializeAutocomplete();
      }, 2000)
    } else {
      const interval = setInterval(() => {
        if (window.google) {
          initializeAutocomplete();
          clearInterval(interval);
        }
      }, 500); // Retry every 500ms until Google API is loaded
    }
  }, [queryParam, navigate, hubdataurl, center.lat, center.lng]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestDataForMap = {
          // Define your request data here or ensure it's passed from elsewhere
          dashboard: queryParam,
          action: 'getstationlist'
        };
        const response = await fetch(hubdataurl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `bearer ${bearerToken}`,
          },
          body: JSON.stringify(requestDataForMap),
        });

        const result = await response.json();

        if (response.ok) {
          setMapData(result.data); // Update data on success
          //console.log(result.data);
        } else {
          // API returned an error
          setMapData([]);
        }
      } catch (error) {
        // Network or other errors
        //console.error("Error fetching station data:", error);
        setMapData([]);
      }
    };

    fetchData();
  }, [hubdataurl, queryParam]);

  // Log updated mapData whenever it changes
  useEffect(() => {
    //console.log("Updated mapData:", mapData);
  }, [mapData]);

  const mapOptions = {
    disableDefaultUI: true,
    zoomControl: true,
  };

  const mapContainerStyle = {
    width: "100%",
    height: mapHeight, // Dynamically set height
  };

  const handleCloseError = () => {
    setIsError(false);
    inputRef.current.value = "";
  };
  const handleActiveMarker = (station) => {
    console.log(station);
    if (station.idStation === activeMarker) {
      // Close the InfoWindow if the same marker is clicked again
      setActiveMarker(null);
      return;
    }
    setActiveMarker(station.idStation); // Set active marker
    setCenter({
      lat: parseFloat(station.stationLat),
      lng: parseFloat(station.stationLong),
    });
    setZoom(16); // Zoom to focus
  };
 
  
  
  
  
  return (
    <section className="swap-bike section-padding-sm">
      <div className="container">
        <div className="swap-bike__header section-header">
          <h2>
            <span>Swap your Bike</span> at any BRTS station
          </h2>
        </div>

        <div className="video">
          <a href={Video} data-fancybox="video-gallery">
            <img
              src={Thumbnail}
              alt="Play Video"
              className="video-thumbnail desk-image"
            />
            <img
              src={ThumbnailMobile}
              alt="Play Video"
              className="video-thumbnail mob-image"
            />
          </a>
        </div>

        <div className="paragraph">
          <p>
            <span>Long commute?</span> Use MYBYK to connect your first and last
            mile with Ahmedabad BRTS.
            <span>
              {" "}
              Drop & Pick MYBYK at <strong>75+ BRTS stations.</strong>
            </span>
          </p>
        </div>

        {isValidParam && (
          <div className="swap-bike__map">
            <div className="search-input-wrapper">
              <input
                type="text"
                ref={inputRef} // Attach the ref to the input field
                placeholder="Search a MYBYK hub near you"
                onChange={(e) => {
                  if (e.target.value.trim() === "") {
                    setZoom(12);
                  }
                }}
              />
            </div>
            <div className="google-map-container">
              {isError && (
                <div className="error_msg-parent">
                  <div className="error_msg-c">
                    <button className="error-msg-b" onClick={handleCloseError}>
                      <img src={CrossIcon} alt="" />
                    </button>
                    <p>{errorMessage}</p>
                    <button className="error_msg-close">Dismiss</button>
                  </div>
                </div>
              )}
              <LoadScript googleMapsApiKey={MapEnv} libraries={libraries}>
                <GoogleMap
                  center={center}
                  zoom={zoom}
                  mapContainerStyle={mapContainerStyle}
                  options={mapOptions}
                  onLoad={(map) => {
                    mapRef.current = map;
                  }}
                >
                  {mapData.stationList?.filter((station) => station.stationLat && station.stationLong).map((station, index) => {
                    const isNearest =
                      center.lat === parseFloat(station.stationLat) &&
                      center.lng === parseFloat(station.stationLong);

                    const isActive = activeMarker === station.idStation;

                    let markerIcon = MyBykStationPin;

                    if (isActive) {
                      markerIcon = MyBykStationPinBig;
                    } else if (isNearest && !isActive) {
                      markerIcon = MyBykStationPin;
                    } else if (isNearest) {
                      markerIcon = MyBykStationPinBig;
                    }

                    return (
                      <Marker
                        key={station.idStation || `marker-${index}`}
                        position={{
                          lat: parseFloat(station.stationLat),
                          lng: parseFloat(station.stationLong),
                        }}
                        title={station.stationName}
                        icon={markerIcon}
                        onClick={() => handleActiveMarker(station)} // Set active marker on click

                        
                      />
                    );
                  })}
                  {/* {activeMarker && (
                    <InfoWindow
                      key={`info-window-${activeMarker}`}
                      position={{
                        lat: parseFloat(
                          mapData.stationList.find(
                            (station) => station.idStation === activeMarker
                          ).stationLat
                        ),
                        lng: parseFloat(
                          mapData.stationList.find(
                            (station) => station.idStation === activeMarker
                          ).stationLong
                        ),
                      }}
                      onCloseClick={() => setActiveMarker(null)} // Close the InfoWindow
                      options={{
                        pixelOffset: new window.google.maps.Size(0, -60), // Adjust as needed to reposition the InfoWindow
                      }}
                    >
                      <div>
                        <h4>
                          {
                            mapData.stationList.find(
                              (station) => station.idStation === activeMarker
                            ).stationName
                          }
                        </h4>
                      </div>
                    </InfoWindow>
                  )} */}
                  {activeMarker && (
                    <InfoWindow
                      key={`info-window-${activeMarker}`}
                      position={{
                        lat: parseFloat(
                          mapData.stationList.find(
                            (station) => station.idStation === activeMarker
                          ).stationLat
                        ),
                        lng: parseFloat(
                          mapData.stationList.find(
                            (station) => station.idStation === activeMarker
                          ).stationLong
                        ),
                      }}
                      onCloseClick={() => setActiveMarker(null)} // Close the InfoWindow
                      options={{
                        pixelOffset: new window.google.maps.Size(0, -60), // Adjust as needed to reposition the InfoWindow
                      }}
                    >
                      <div>
                        <h4>
                          {
                            mapData.stationList.find(
                              (station) => station.idStation === activeMarker
                            ).stationName
                          }
                        </h4>
                      </div>
                    </InfoWindow>
                  )}

                </GoogleMap>
              </LoadScript>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default SwapYourBike;
